/** @format */

import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { faTriangleExclamation } from "@fortawesome/sharp-solid-svg-icons";

import {
  faCarSide,
  faClock,
  faExchangeAlt,
  faFlag,
  faFlagCheckered,
  faGasPump,
  faInfoCircle,
  faStopwatch,
  faTrophy,
} from "@/utils/iconLibraryTreeShake";

export interface NotificationCategoryStyle {
  icon: IconDefinition;
  color: string;
  hex: string;
}

// Category-specific icon and color configuration
export const CATEGORY_CONFIG: Record<string, NotificationCategoryStyle> = {
  race_start: { icon: faFlagCheckered, color: "text-green-400", hex: "#4ade80" },
  race_end: { icon: faTrophy, color: "text-yellow-400", hex: "#facc15" },
  qualifying_start: { icon: faStopwatch, color: "text-purple-400", hex: "#c084fc" },
  qualifying_end: { icon: faStopwatch, color: "text-purple-400", hex: "#c084fc" },
  race_incident: { icon: faFlag, color: "text-yellow-400", hex: "#facc15" },
  lead_change: { icon: faExchangeAlt, color: "text-blue-400", hex: "#60a5fa" },
  race_fastest_lap: { icon: faStopwatch, color: "text-orange-400", hex: "#fb923c" },
  favorite_driver_position: {
    icon: faCarSide,
    color: "text-purple-400",
    hex: "#c084fc",
  },
  favorite_driver_incident: {
    icon: faTriangleExclamation,
    color: "text-red-400",
    hex: "#f87171",
  },
  favorite_driver_pit: { icon: faGasPump, color: "text-blue-400", hex: "#60a5fa" },
  schedule_reminder: { icon: faClock, color: "text-slate-400", hex: "#94a3b8" },
};

// Incident type to icon/color mapping for race_incident category
export const INCIDENT_TYPE_CONFIG: Record<string, NotificationCategoryStyle> = {
  green: { icon: faFlag, color: "text-green-400", hex: "#4ade80" },
  long_green: { icon: faFlag, color: "text-green-400", hex: "#4ade80" },
  caution: { icon: faFlag, color: "text-yellow-400", hex: "#facc15" },
  red_flag: { icon: faFlag, color: "text-red-400", hex: "#f87171" },
  checkered: { icon: faFlagCheckered, color: "text-slate-200", hex: "#e2e8f0" },
  pre_race: { icon: faFlagCheckered, color: "text-slate-400", hex: "#94a3b8" },
  post_race: { icon: faFlagCheckered, color: "text-slate-400", hex: "#94a3b8" },
  overtime: { icon: faFlagCheckered, color: "text-orange-400", hex: "#fb923c" },
};

export const DEFAULT_CONFIG: NotificationCategoryStyle = {
  icon: faInfoCircle,
  color: "text-slate-400",
  hex: "#94a3b8",
};

export function getNotificationConfig(
  category: string,
  incidentType?: string
): NotificationCategoryStyle {
  if (category === "race_incident" && incidentType) {
    const incidentConfig = INCIDENT_TYPE_CONFIG[incidentType];
    if (incidentConfig) {
      return incidentConfig;
    }
  }
  return CATEGORY_CONFIG[category] || DEFAULT_CONFIG;
}
